import es from 'element-ui/lib/locale/lang/es';

export default {
  element: es,
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/element.js